import type { Chat } from "@ai-sdk/react";
import { createContext, useContext } from "react";
import type { LimeAiUIMessage } from "./types";

export type AiChatContextValue = {
  chat: Chat<LimeAiUIMessage>;
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
  /** Abandons the current conversation and starts an empty one. */
  startNewChat: () => void;
};

export type AiChatWidthContextValue = {
  width: number;
  commitWidth: (width: number) => void;
};

export const AiChatContext = createContext<AiChatContextValue | null>(null);

/** Separate context so a resize drag does not re-render the transcript. */
export const AiChatWidthContext = createContext<AiChatWidthContextValue | null>(
  null,
);

export function useAiChat() {
  const value = useContext(AiChatContext);
  if (!value) {
    throw new Error("useAiChat must be used inside AiChatProvider");
  }
  return value;
}

/** Null until the chat has loaded, and always for users without access. */
export function useOptionalAiChat() {
  return useContext(AiChatContext);
}

export function useAiChatWidth() {
  const value = useContext(AiChatWidthContext);
  if (!value) {
    throw new Error("useAiChatWidth must be used inside AiChatProvider");
  }
  return value;
}
